/**
 * The frame a looping animation would be on had it started at the Unix epoch.
 * Loaders mounted one after another, or by the next page load, then continue
 * one loop instead of each restarting from the first frame.
 */
export function getWallClockLoopFrame({
  frameRate,
  frameCount,
  now = Date.now(),
}: {
  frameRate: number;
  frameCount: number;
  now?: number;
}): number {
  const loopMs = (frameCount / frameRate) * 1000;
  return Math.floor(((now % loopMs) / loopMs) * frameCount);
}
